import React from 'react';
import KickImage from 'Reuseables/KickImage';
import styled from 'styled-components';
import ReactLoading from 'react-loading';
import propTypes from 'prop-types';

const LoadingDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 150px;
  flex-direction: column;
`

const Loading = ({ color, height, width, type }) =>(
  <LoadingDiv>
    <ReactLoading type={type} height={height} width={width} color={color} />
    <p>Please wait, connecting with the payment...</p>
  </LoadingDiv>
)

Loading.defaultProps = {
  type: 'bars',
  height: 80,
  width: 80,
  color: '#159953'
}

Loading.propTypes = {
  type: propTypes.string,
  height: propTypes.number,
  width: propTypes.number,
  color: propTypes.string
}

export default Loading;
